import React, { forwardRef, HTMLAttributes, ReactNode } from 'react';

type Props = HTMLAttributes<HTMLDivElement> & {
    readonly maxHeight?: string;
    readonly children?: ReactNode;
};

const ScrollWrapper = forwardRef<HTMLDivElement, Props>((props, ref) => {
    const { className, style = {}, maxHeight = '300px', children } = props;

    return (
        <div ref={ref} className={className} style={{ ...style, maxHeight, overflow: 'auto' }}>
            {children}
        </div>
    );
});

export default ScrollWrapper;
